import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  .table-component {
    > .incident {
    td {
      background: #d9d9d9 !important;
    }

    .task_name {
      td {
        background: #f4faff !important;
      }

      .report_task {
        td {
          background: #f6feff !important;
        }
  }
  textarea {
    border-radius: 10px;
  }
`

export default Styled
